import axios, { AxiosHeaders, AxiosRequestHeaders, InternalAxiosRequestConfig } from "axios";

const axiosAuth = axios.create();

axiosAuth.interceptors.request.use(
     (req: InternalAxiosRequestConfig) => {
        const token = sessionStorage.getItem('token')
        if(!!token) {
            let headers: AxiosRequestHeaders = req.headers;
            if (!headers) {
                headers = new AxiosHeaders();
            }
            headers.set('Authorization', `Bearer ${token}`);
        }
        return req;
    },
    (err) => {
        return Promise.reject(err);
    }
);

axiosAuth.interceptors.response.use(
    (res) => {
        return res;
    },
    (err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
            sessionStorage.removeItem('token')
            window.location.href = loginPath();
        }
        return Promise.reject(err);
    }
);

export default axiosAuth;

export const loginPath = () => {
    return process.env.REACT_APP_LOGIN_PATH || '/';
}